import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, Subject, concatMap, interval, of, switchMap } from 'rxjs';
import { SuscriptionsWS } from '../interfaces/suscription.interface';

@Injectable({
  providedIn: 'root'
})
export class SuscriptionService {

  private dispositivoSeleccionado: BehaviorSubject<{id: number , nombre: string, dispositivo: any, index:number} >;
  private dispositivoConectado = new Subject<any>();
  private dispositivosCatalogo = new Subject<SuscriptionsWS>();

  private syncingDeviceIdSubject: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  syncingDeviceId$ = this.syncingDeviceIdSubject.asObservable();

  private customerIdSubject: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  customerId$ = this.syncingDeviceIdSubject.asObservable();
  
  private totalMessages = new Subject<number>();

  private baseApiSuscripciones = environment.baseApi + '/suscripciones';
  private baseApiSuscriptionsXclient = environment.baseApi + '/catalog';

  constructor(private http: HttpClient) {
    const data:{id: number , nombre: string, dispositivo: any, index:number} = {id: 0 , nombre: '', dispositivo: {id:0}, index:0}
    this.dispositivoSeleccionado = new BehaviorSubject(data);
    const deviceSincronizar =  localStorage.getItem('deviceSincronizar')
    const customerId =  localStorage.getItem('idCustomerSync')
    const deviceNew: number | null = deviceSincronizar == null? null : JSON.parse(deviceSincronizar) 
    this.syncingDeviceIdSubject = new BehaviorSubject<number | null>(deviceNew);
  }

  obtenerSuscripcion(id: number, idRol: number) {
    return this.http.get<any>(`${this.baseApiSuscripciones}/${id}/${idRol}`).toPromise();
  }

  catalogoSuscripciones(id: number, idRol: number, isChats: boolean) {
    return this.http.get<any>(`${this.baseApiSuscriptionsXclient}/suscriptions/${id}/${idRol}/${isChats}`).toPromise();
  }

  actualizarNombreSuscripcion(nombre: String, idsuscripcion: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { nombre: nombre, id: idsuscripcion };
    return this.http.put<any>(`${this.baseApiSuscripciones}/${nombre}/${idsuscripcion}`, body, { headers }).toPromise();
  }

  desactivarDispositivo(idSuscription: number, idCustomer: number) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<any>(`${this.baseApiSuscripciones}/disconnect/${idSuscription}/${idCustomer}`, { headers }).toPromise();
  }

  vicularDispositivo(idSuscription: number, idCustomer: number, idUser: number | undefined) {
    return this.http.get<any>(`${environment.baseApi}/link-suscription/${idSuscription}/${idCustomer}/${idUser}`).toPromise();
  }


  cargarMasChats(idSuscription: number, idCustomer: number, idUser: number | undefined): Observable<any> {
    const endpoint = `${environment.baseApi}/load-more-messages/${idSuscription}/${idCustomer}/${idUser}`;
    
    const recursiveFetch = (url: string): Observable<any> => {
      return this.http.get<any>(url).pipe(
        concatMap((response: any) => {
          console.log(response);
          const moreDataAvailable = response.data !== null; // Verifica si hay más datos
          const canceloProceso = moreDataAvailable && response.data.finalizoProceso !== null && response.data.finalizoProceso;
          const finalizo = moreDataAvailable && response.data.finalizoSync !== null && response.data.finalizoSync;
        
          // Realiza otra solicitud si hay más datos, de lo contrario, completa el flujo
          return moreDataAvailable ? canceloProceso || finalizo? of(response): recursiveFetch(url) : of(null);
        })
      );
    };
  
    return recursiveFetch(endpoint);
  }

  establecerDispositivo(data: any){
    this.dispositivoSeleccionado.next(data);
  }
  get dispositivo() {
    return this.dispositivoSeleccionado.value;
  }


  establecerConeccion(value: any){
    this.dispositivoConectado.next(value);
  }
  eventoConexion(){
    return this.dispositivoConectado.asObservable();
  }


  establecerDispositivos(dispositivos: SuscriptionsWS){
    this.dispositivosCatalogo.next(dispositivos);
  }
  dispositivos(){
    return this.dispositivosCatalogo.asObservable();
  }



  setSyncingDeviceId(deviceId: number | null) {
    this.syncingDeviceIdSubject.next(deviceId);
    localStorage.setItem('deviceSincronizar', JSON.stringify(deviceId))
    console.log(deviceId)
  }

  setCustomerSyncId(customerId: number | null) {
    this.customerIdSubject.next(customerId);
    localStorage.setItem('idCustomerSync', JSON.stringify(customerId))
    console.log('idcustomer', customerId)
  }

  getSyncingDeviceId(){
    return this.syncingDeviceIdSubject.asObservable()
  }

  getCustomerSyncId(){
    return this.customerIdSubject.asObservable()
  }

  setTotalMessages(deviceId: number ) {
    this.totalMessages.next(deviceId);
  }

  getTotalMessages(){
    return this.totalMessages.asObservable()
  }

}
